import { useCallback, useEffect, useState, type RefObject } from "react";

/** 横向标签滚动区右侧渐变：有溢出且未滑到底时显示 */
export function useTabsScrollFadeRight(
  tabsScrollRef: RefObject<HTMLElement | null>,
  recomputeKey: unknown
): boolean {
  const [showFade, setShowFade] = useState(false);

  const sync = useCallback(() => {
    const el = tabsScrollRef.current;
    if (!el) {
      setShowFade(false);
      return;
    }
    const overflow = el.scrollWidth > el.clientWidth + 1;
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
    setShowFade(overflow && !atEnd);
  }, [tabsScrollRef]);

  useEffect(() => {
    const el = tabsScrollRef.current;
    if (!el) {
      return undefined;
    }

    sync();
    const raf = requestAnimationFrame(sync);

    el.addEventListener("scroll", sync, { passive: true });
    el.addEventListener("touchend", sync, { passive: true });

    const ro = new ResizeObserver(sync);
    ro.observe(el);
    const inner = el.firstElementChild;
    if (inner instanceof Element) {
      ro.observe(inner);
    }

    window.addEventListener("resize", sync);

    return () => {
      cancelAnimationFrame(raf);
      el.removeEventListener("scroll", sync);
      el.removeEventListener("touchend", sync);
      ro.disconnect();
      window.removeEventListener("resize", sync);
    };
  }, [tabsScrollRef, sync, recomputeKey]);

  return showFade;
}
